"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonTitle = void 0;
var _localization = require("@lt/localization");
var getButtonTitle = exports.getButtonTitle = function getButtonTitle(searchType, isRequestCancellation) {
  if (isRequestCancellation) {
    return "".concat(_localization.i18n.t('orderPage.orderCancellation.confirmationTitleRequest', {
      context: searchType
    }));
  }
  return "".concat(_localization.i18n.t('orderPage.orderCancellation.title', {
    context: searchType
  }));
};